import { Button, Card } from "react-bootstrap";
import { eInteraction, Interaction } from "../../../@types/Interaction";
import { Post } from "../../../@types/Posts";
import usePostContext from "../../../context/PostContext";
import { useState, useEffect } from "react";
import Comment from "./Comment";
import { User } from "../../../@types/Users";
import { orderBy, slice } from "lodash";
import { projectPrimaryColor } from "../../../generalConfigs";

interface Props {
  post: Post;
  user: User;
}

export function Comments({ post, user }: Props) {
  const [comments, setComments] = useState<Interaction[]>([]);
  const [maxIndex, setMaxIndex] = useState<number>(2);
  const [enableShowMore, setEnableShowMore] = useState<boolean>(false);

  const { interactions } = usePostContext();

  const maxCommentsPerPage = 2;
  const commentsSliced = slice(comments, 0, maxIndex);

  useEffect(() => {
    const commentsFiltered = interactions.filter(
      (interaction) => interaction.type === eInteraction.COMMENT
    );

    const commentsOrdered = orderBy(
      commentsFiltered,
      (reaction) => {
        return new Date(reaction.created_at);
      },
      "desc"
    );

    setComments(commentsOrdered);

    const totalItems = commentsOrdered.length;
    if (totalItems > maxIndex) {
      setEnableShowMore(true);
    } else {
      setEnableShowMore(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interactions, maxIndex]);

  function handleViewMore() {
    setMaxIndex(maxIndex + maxCommentsPerPage);
  }

  return (
    <Card
      style={{
        borderEndStartRadius: 15,
        borderEndEndRadius: 15,
      }}
      className="bd-r-0 bd-t-0 bd-l-0 bd-b-0 mg-t-2"
    >
      <Card.Body className="bd-t-0">
        {commentsSliced.map((reaction, i) => {
          return (
            <div key={i}>
              {i > 0 && <hr className="wd-100p" style={{ borderColor: "var(--border-2)" }} />}
              <Comment comment={reaction} user={user} />
            </div>
          );
        })}
        {enableShowMore && (
          <div className="text-center">
            <Button
              style={{
                cursor: "pointer",
                backgroundColor: projectPrimaryColor,
                borderRadius: 15,
              }}
              onClick={handleViewMore}
            >
              Carregar mais comentários
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
